import { loginRequest, msalInstance } from '@/auth/msalConfig';

/** `BrowserAuthErrorCodes.interactionInProgress` de MSAL. */
const INTERACTION_IN_PROGRESS = 'interaction_in_progress';

// 🔴 Logout abandonado: `logoutRedirect` marca la interacción como "en curso" en sessionStorage y se
// va a Microsoft. Si la persona pulsa Atrás en vez de elegir la cuenta, el navegador restaura la app
// desde el back/forward cache, congelada a medio cierre (spinner sin fin), y la marca nunca se limpia:
// MSAL solo la limpia al arrancar (`handleRedirectPromise`) y en una restauración no se arranca nada.

/** Restaurada desde el back/forward cache → recarga, para que el arranque normal limpie la marca. */
export function reloadIfRestoredFromCache(event: PageTransitionEvent): void {
  if (event.persisted) window.location.reload();
}

/** "Entra con correo Sigma". Con la marca colgada `loginRedirect` rechaza con
 *  `interaction_in_progress` y, descartado con `void`, el botón no hacía nada. */
export async function startCorporateLogin(): Promise<void> {
  try {
    await msalInstance.loginRedirect(loginRequest);
  } catch (error) {
    if ((error as { errorCode?: string } | null)?.errorCode === INTERACTION_IN_PROGRESS) {
      window.location.reload();
    }
  }
}
